/*
We're constantly improving the code you see. 
Please share your feedback here: https://form.asana.com/?k=uvp-HPgd3_hyoXRBw1IcNg&d=1152665201300829
*/

import PropTypes from "prop-types";
import React from "react";
import "./style.css";

export const WebInsightCard = ({
  title = "Available technology",
  description = "Wearables, surfaces with embedded sensors, vision- and environmental-based solutions, and smart containers are available technologies for automatic fluid intake monitoring.",
  className,
}) => {
  return (
    <div className={`WEB-INSIGHT-CARD ${className}`}>
      <div className="available-technology">{title}</div>
      <p className="wearables-surfaces">{description}</p>
    </div>
  );
};

WebInsightCard.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
};
